import {useArbitrary} from '~/hooks'
import {date} from '@eitje/utils'

export const useGraphData = ({dataType, graphVariantsTaxonomy}) => {
	const monthlyData = useArbitrary(dataType)

	if (!monthlyData) return []

	return graphVariantsTaxonomy.map(({name, accessorFn}) => ({
		name,
		data: monthlyData.map(row => {
			const moment = date()
				.year(row.year)
				.month(row.month - 1)
				.date(1)

			const value = accessorFn ? accessorFn(row) : row[name]

			return {x: moment.valueOf(), y: value}
		}),
	}))
}
